export default __webpack_public_path__ + "static/media/add.055ca18a.svg";